import React, { useState } from "react";
import { useParams } from "react-router-dom";

import Button from "../../../../../../components/Button";
import ContentModal from "../../../../../../components/Modal/Templates/ContentModal";
import Spacer from "../../../../../../components/Spacer";
import Typography from "../../../../../../components/Text";
import { TextEditor } from "../../../../../../components/TextEditor";

import {
	useGoalDetails,
	useGoalHistory,
	useMutateGoalDetails,
	useRbacObjectPermissions,
} from "../../../../../../api/hooks";
import useSearchQueryParams from "../../../../../../hooks/useSearchQueryParams";

import { Goal } from "../../../../../../api/services";

import { parseGoalPermissionsForUser } from "../../../utils";

import Config from "../../../config";
import css from "./CompleteGoalModal.module.scss";

const CompleteGoalModal = () => {
	const { goal_id: goalId } = useParams<{ goal_id: string }>();
	const [message, setMessage] = useState("");
	const {
		queryParams: { modal },
		handleQueryChange,
	} = useSearchQueryParams({
		schema: Config.queryParametersSchema,
	});

	const { data, refetch: refetchGoal } = useGoalDetails({ goalID: goalId || "" });
	const goal = data ? data.goal : ({} as Goal);
	const { data: permissions } = useRbacObjectPermissions("goal", goalId || "");
	const { userCanEditStatus } = parseGoalPermissionsForUser(permissions);

	const { refetch: refetchProgress } = useGoalHistory({
		goalID: goalId || "",
		type: "progress",
		sortDirection: "desc",
		sortName: "as_of",
	});

	const { refetch: refetchActivity } = useGoalHistory({
		goalID: goalId || "",
		sortDirection: "desc",
		sortName: "_id",
	});

	const { mutate, isPending } = useMutateGoalDetails(goalId || "", {
		onSuccess: () => {
			handleQueryChange({ modal: undefined });
			refetchGoal();
			refetchProgress();
			refetchActivity();
		},
	});

	const closeModal = () => handleQueryChange({ modal: undefined });
	return (
		<ContentModal
			isOpen={modal === "complete"}
			handleClose={closeModal}
			title={
				<div className={css.modalHeader}>
					<Typography size="sub-heading" weight="semi-bold">
						Mark as Complete?
					</Typography>
					<Typography color="neutral-4" size="paragraph-2" weight="regular">
						{goal?.name}
					</Typography>
				</div>
			}
			buttons={[
				<Button key="cancel-complete-goal" testid="cancel-complete-goal" onClick={closeModal}>
					Cancel
				</Button>,
				<Button
					key="complete-goal"
					testid="complete-goal"
					color="green"
					isRequesting={isPending}
					disabled={!userCanEditStatus}
					onClick={() => {
						const updatedData = [{ field: "status", value: "done" }];

						if (message) {
							updatedData.push({ field: "message", value: message });
						}

						mutate(updatedData);
					}}
				>
					Yes, Complete Goal
				</Button>,
			]}
		>
			<div className={css.messageContainter}>
				<Typography size="paragraph-3" weight="semi-bold">
					Message
				</Typography>
				<Spacer height={1} />
				<TextEditor
					className={css.messageEditor}
					initialValue=""
					isRichText={false}
					placeholder="Add Message"
					id="message-update goal complete"
					onChange={(value) => setMessage(value)}
				/>
			</div>
		</ContentModal>
	);
};

export default CompleteGoalModal;
